import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CatalogDetInfo } from '../model/dictionary/CatalogDetInfo';
import { ImageCollectorDto } from '../model/dto/ImageCollectorDto';
import { RequestResponse } from '../model/dto/RequestResponse';
import { ImageCollector } from '../model/ImageCollector';

@Injectable()
export class ImageCollectorFacade {

  private _urlBase: string;
  private _httpClient: HttpClient;

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this._urlBase = baseUrl;
    this._httpClient = http;
  }

  SaveImage(imgCollector: ImageCollectorDto): Observable<RequestResponse<number>> {
      return this._httpClient.post<any>(this._urlBase + 'api/ImageCollector/', imgCollector);
  }

  ActivateImage(imageCollector: ImageCollector): Observable<RequestResponse<number>> {
    return this._httpClient.put<RequestResponse<number>>(this._urlBase + 'api/ImageCollector/', imageCollector );
  }

  GetImageCollectorByOrganizationModule(organizationId: string, catDetMobileModuleId: number)
    : Observable<RequestResponse<ImageCollector[]>> {
      return this._httpClient.get<RequestResponse<ImageCollector[]>>(this._urlBase + 'api/ImageCollector/?catDetMobileModuleId='
      + catDetMobileModuleId + '&organizationId=' + organizationId);
  }

}
